module.exports = __webpack_public_path__ + "img/pp12.f66eb584.png";